export default {
    isMetaWhatsappConnected: state => !!(state.metaWhatsappAuth && state.metaWhatsappAuth.connected),
    metaWhatsappAuth:        state => state.metaWhatsappAuth,
    metaWhatsappConnecting:  state => state.metaWhatsappConnecting,
    metaWhatsappError:       state => state.metaWhatsappError,
}


// WEBPACK FOOTER //
// ./src/modules/metaWhatsappApi/getters.js